// extracted by mini-css-extract-plugin
module.exports = {"publicationDetails":"styles_publicationDetails__1M18x","readTime":"styles_readTime__2ZjOf"};